module.exports = __webpack_public_path__ + "static/media/maf.79e3ff66.jpg";